// extracted by mini-css-extract-plugin
export default {"react-player-wrapper":"VideoDetail_react-player-wrapper__FnK3P","react-player":"VideoDetail_react-player__z9LSl"};